import { render, staticRenderFns } from "./HistoryView.vue?vue&type=template&id=de6be08e&scoped=true"
import script from "./HistoryView.vue?vue&type=script&lang=js"
export * from "./HistoryView.vue?vue&type=script&lang=js"
import style0 from "./HistoryView.vue?vue&type=style&index=0&id=de6be08e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de6be08e",
  null
  
)

export default component.exports